import React from 'react';
import connectToStores from 'alt-store-connect';
import PageStore from '../../stores/page';
import Confirm from '../generic/confirm';
import { Glyphicon } from 'react-bootstrap';
import EditorActions from '../../actions/editor';
import { pathOr } from 'ramda';

@connectToStores
class TabHeaderItem extends React.Component {

    constructor(props) {
        super(props);

        this.state = { showConfirm: false };

        this.onClose = this.onClose.bind(this);
    }

    static getStores() {
        return [PageStore];
    }

    static getPropsFromStores() {
        return {
            pageStore: PageStore.getState(),
        };
    }

    onClose(e) {

        const editorId = e.currentTarget.id;
        const { editor } = this.props;
        const editorIsPageType = editor.type.toUpperCase() === 'PAGE';
        const page = editorIsPageType ? this.props.pageStore.models[editor.pageId] : null;
        const needsConfirmation = editorIsPageType && pathOr(false, ['isDirty'], page);

        e.preventDefault();
        e.stopPropagation();

        if (needsConfirmation) {
            this.setState({ showConfirm: true });
        } else {
            EditorActions.close(editorId, editor.flowId);
        }
    }

    renderCloseConfirm(show, editor) {

        const title = 'Close Page Layout';
        const messages = [
            'This page layout contains unsaved changes. If you close this page layout they will be lost.',
            'Are you sure you want to close the page layout?'
        ];
        const onCancel = () => this.setState({ showConfirm: false });
        const onConfirm = (e) => {
            this.setState({ showConfirm: false });
            EditorActions.close(editor.id);
        }

        const confirmProps = {
            title,
            messages,
            onCancel,
            onConfirm,
            show
        };

        return <Confirm {...confirmProps} />;
    }

    render() {
        const { editor } = this.props;

        let className = 'tab-header-item ';
        if (editor.isActive) {
            className += 'active';
        }

        let icon = editor.icon ? editor.icon.replace('glyphicon-', '') : null;

        switch (editor.type.toUpperCase()) {
        case 'PAGE':
        case 'NEW_PAGE':
            icon = 'th';
            break;
        case 'FLOW':
            icon = 'leaf';
            break;
        case 'ADMIN':
            icon = 'home';
            break;
        default:
        }

        let iconElement = <Glyphicon glyph={icon} />;
        let titleElement = <span className="tab-header-item-label">{editor.title}</span>;
        let closeElement = <Glyphicon glyph="remove" id={editor.id} onClick={this.onClose} />;

        const isAdminTab = editor.type.toUpperCase() === 'FLOWS';

        // Screen space is very limited, so there is no need to show the tab title text
        // Not active tab
        // [(icon)]
        // Active tab
        // [(x)]
        if (this.props.hideTitles) {
            // Don't show the title as there is no space for text
            titleElement = null;
            className += ' center-content icon-only';
            if (editor.isActive && isAdminTab === false) {
                // Don't show the icon of the current tab as there is no room for it and the 'x'
                // Unless in the admin tab, because that can't have an 'x'
                iconElement = null;
            }
        }

        // Screen space is starting to get tight, so we choose not to show close buttons for other tabs
        // as it is making the tab title text hard to read
        // Not active tab
        // [(icon) Flow 1]
        // Active tab
        // [(icon) Flow 1 (x)]
        if (
            (this.props.hideCloseButtons && editor.isActive === false) ||
            isAdminTab
        ) {
            // Don't show the close button as there is no space for it and the tab name
            // And don't show a close option for the admin tab
            closeElement = null;
        }

        // By default with no special measures active
        // Active and not active tabs
        // [(icon) Flow 1 (x)]
        return (
            <div className={className} title={editor.title} id={editor.id} data-tab-type={editor.type} data-tab-key={editor.key} onClick={this.props.onSelect}>
                {iconElement}
                {titleElement}
                {closeElement}
                {
                    this.renderCloseConfirm(this.state.showConfirm, editor)
                }
            </div>
        );
    }

}

TabHeaderItem.displayName = 'TabHeaderItem';

export default TabHeaderItem;
